import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class DistrictMapperError extends IncError {
    constructor() {
        super(i18n.t("error:beneficiary.district.districtMapperError"));

        Object.setPrototypeOf(this, DistrictMapperError.prototype);
    }
}